import { FilterDefn } from '../../index';
import { FilterChecklist } from '../FilterChecklist';
import { keyForOption } from '../utils';

type MultiListProps = {
    options: FilterDefn[];
};

export const MultiList = ({ options }: MultiListProps): JSX.Element => {
    return (
        <div className="FilterMultiList">
            {options.map((option) => (
                <FilterChecklist key={keyForOption(option)} option={option} />
            ))}
        </div>
    );
};
